import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class BinaryBytesPerSecUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Bytes(binary)/sec'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: BinaryBytesPerSecUnitConverter;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!BinaryBytesPerSecUnitConverter.instance) {
      BinaryBytesPerSecUnitConverter.instance = new BinaryBytesPerSecUnitConverter();
    }
    return BinaryBytesPerSecUnitConverter.instance;
  }

  protected units = [
    'bit (b)/sec - Bytes(binary)/sec',
    'byte (B)/sec - Bytes(binary)/sec',
    'kibibyte (KiB)/sec',
    'mebibyte (MiB)/sec',
    'gibibyte (GiB)/sec',
    'tebibyte (TiB)/sec',
    'pebibyte (PiB)/sec',
    'exbibyte (EiB)/sec',
  ] as const;

  protected unitToBase = {
    'bit (b)/sec - Bytes(binary)/sec': 1,
    'byte (B)/sec - Bytes(binary)/sec': 8,
    'kibibyte (KiB)/sec': 8 * 1024,
    'mebibyte (MiB)/sec': 8 * 1024 ** 2,
    'gibibyte (GiB)/sec': 8 * 1024 ** 3,
    'tebibyte (TiB)/sec': 8 * 1024 ** 4,
    'pebibyte (PiB)/sec': 8 * 1024 ** 5,
    'exbibyte (EiB)/sec': 8 * 1024 ** 6,
  };
}
